import { Outlet } from 'react-router-dom';

import { GoalsReminder } from '@/components/goals/GoalsReminder';

import { BottomNav } from './BottomNav/BottomNav';
import { Header } from './Header/Header';
import { NpiNotice } from './NpiNotice';
import { SideNav } from './SideNav/SideNav';
import styles from './AppLayout.module.css';

/**
 * Shell rendered around every authenticated page.
 *
 * Layout (modern dashboard pattern):
 *   - >=900px: full-width Header on top → row with slim icon SideNav rail (left)
 *     + content column. Mirrors Linear/Notion/Vercel-style chrome.
 *   - <900px: Header on top, content scrolls, BottomNav anchored to the bottom.
 *
 * Pages own their own padding so they can decide how to fill the canvas.
 */
export function AppLayout() {
  return (
    <div className={styles.shell}>
      <Header />
      <div className={styles.body}>
        <SideNav />
        <main className={styles.main}>
          <NpiNotice />
          <GoalsReminder />
          <Outlet />
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
